import React from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { ON_DUPLICATE_CHOICES, duplicateChoices, duplicateNote } from './missedCallFormat';

/**
 * The 합치기 / 새 행 / 무시 question for a number already on today's list — one copy for the screenshot review (desktop
 * and phone) and 번호로 추가. All three outcomes are spelled out before one is picked, and the picked one stands out;
 * unanswered, the whole thing is amber and saving waits for an answer (reviewRowError).
 *
 * Props: candidate (with merge_into) · value · onChange(choice) · disabled · fullWidth (phone) · boxed (a bordered card) ·
 * timeUnknown (a past day's row left without a time — 합치기 then only adds to the count).
 */
const DuplicateChoice = ({ candidate, value, onChange, disabled = false, fullWidth = false, boxed = false, timeUnknown = false }) => {
    if (!candidate?.merge_into) return null;
    const unanswered = !value;
    const body = (
        <>
            <Typography variant="caption" display="block" color={unanswered ? 'warning.main' : 'text.primary'}>
                {duplicateNote(candidate)}
            </Typography>
            <ToggleButtonGroup
                size="small"
                exclusive
                fullWidth={fullWidth}
                value={value}
                disabled={disabled}
                onChange={(e, v) => v && onChange(v)}
                sx={{
                    mt: 0.5,
                    ...(unanswered ? { '& .MuiToggleButton-root': { borderColor: 'warning.main', color: 'warning.main' } } : {}),
                }}
            >
                {ON_DUPLICATE_CHOICES.map((o) => (
                    <ToggleButton
                        key={o.value}
                        value={o.value}
                        sx={{ textTransform: 'none', ...(fullWidth ? { py: 0.5, fontSize: 14 } : { px: 1, py: 0.25 }) }}
                    >
                        {o.label}
                    </ToggleButton>
                ))}
            </ToggleButtonGroup>
            <Box sx={{ mt: 0.5 }}>
                {duplicateChoices(candidate, { timeUnknown }).map((c) => (
                    <Typography
                        key={c.value}
                        variant="caption"
                        display="block"
                        data-choice={c.value}
                        sx={{ fontWeight: value === c.value ? 700 : 400 }}
                        color={value && value !== c.value ? 'text.disabled' : (unanswered ? 'warning.main' : 'text.primary')}
                    >
                        {c.label} — {c.text}
                    </Typography>
                ))}
            </Box>
        </>
    );
    if (!boxed) return body;
    return (
        <Box sx={{ mt: 1, p: 1, borderRadius: 1, border: '1px solid', borderColor: unanswered ? 'warning.main' : 'divider' }}>
            {body}
        </Box>
    );
};

export default DuplicateChoice;
